import React, { Component } from 'react';

class RestrictedImp extends Component {

  render() {
    return (
      <div className= "restrict_wrapper">
        <div>
          You are not authorized for this request.
        </div>
      </div>
    )
  }
}


export default RestrictedImp;


// WEBPACK FOOTER //
// ./src/components/Common/Restricted.jsx